import { render } from "./index.vue?vue&type=template&id=5ae474eb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5ae474eb&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae474eb"]])

export default __exports__